import useCreateConversationAndRedirect from '@website/components/chat/utils/useCreateConversationAndRedirect';
import { createMainContactsText } from '@website/components/me/bookings/sections/Host';
import { Store } from '@website/Store';
import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { MdChat, MdPhone } from 'react-icons/md';
import { HelpBooking } from '../SelectBooking';

export default function AskYourGuide({ booking }: { booking: HelpBooking }) {
  const headGuidesText = createMainContactsText(booking.trip.host.team);

  const { state } = useContext(Store);

  const createChannelAndRedirect = useCreateConversationAndRedirect(
    state.user.id,
    booking.trip.host.id,
  );

  return (
    <div className="mt-3">
      <h2 className="h4">{headGuidesText}</h2>

      <p>
        You can ask them a question with the link below, or give them a call.
      </p>

      <div className="mb-4">
        <Button
          onClick={() => createChannelAndRedirect()}
          className="mb-2 me-2"
        >
          <label className="my-0 me-2">
            <MdChat size="1.4em" />
          </label>
          Message your guide
        </Button>

        <a
          href={`tel:${booking.trip.host.contact.phone}`}
          className="btn btn-muted mb-2 me-2"
        >
          <label className="my-0 me-2">
            <MdPhone size="1.4em" />
          </label>
          {booking.trip.host.contact.phone}
        </a>
      </div>
    </div>
  );
}
